import { useQuery } from "@tanstack/react-query";
import i18n from "@/i18n";
import { api } from "@/lib/api";

export const meKey = ["me"] as const;

/**
 * Who is signed in, and which korpsen they may act for. A 401 is a normal answer here, not an
 * error - it is how the shell decides to render the sign-in state.
 */
export function useMe() {
  return useQuery({
    queryKey: meKey,
    queryFn: async () => {
      const { data, response } = await api.GET("/api/me");
      if (response.status === 401) return null;
      if (!data)
        throw new Error(i18n.t("common:errors.sessie", { status: response.status }));
      return data;
    },
    retry: false,
  });
}
